import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-ui-article-counter-v2',
    templateUrl: './article-counter-v2.component.html',
    styleUrl: './article-counter-v2.component.scss',
    standalone: false
})
export class ArticleCounterV2Component {
  @Input() id: number;
  @Input() maxNumberOfElements: number;
  @Input() numberOfAddedProducts: number;

  @Output() numberOfProductsChanged = new EventEmitter<number>();

  onIncreaseQuantity() {
    if (this.numberOfAddedProducts >= this.maxNumberOfElements) {
      return;
    }
    this.numberOfAddedProducts++;
    this.changeNumberOfProducts();

  }

  onDecreaseQuantity() {
    if (this.numberOfAddedProducts < 1) {
      return;
    }
    this.numberOfAddedProducts--;
    this.changeNumberOfProducts();
  }

  changeNumberOfProducts() {
    this.numberOfProductsChanged.emit(this.numberOfAddedProducts);
  }

}
